import { IEditTatPayload, ITatListSearch } from "../../../../types/master/tatInterface";
import api from "../../../../lib/api";

// export const createTatApi = async (data: ITatCreate) => {
//   return await api.post(`/tat`, data);
// };

export const getTatListApi = async (data: ITatListSearch) => {
  return await api.get(`tat/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};


export const getTatDataByIdApi = async (id: number) => {
  return await api.get(`/tat/${id}`);
};

export const editTatDataByIdApi = async (payload: IEditTatPayload) => {
  return await api.put(`/tat/${payload.id}`, payload.data);
};
